/*
* This reducer file handles reducer's state for all actions that are related to manuals
*/
const initialState = {
  items: [],
  isFetched: false,
  isFetching: true,
  manualRemovedByAdmin: false,

};

export default function manuals(state = initialState, action) {
  switch(action.type) {
    case 'MANUALS_FETCH_REQUEST':
      return Object.assign({}, state, {
        items: null,
        isFetching: true,
        isFetched: false
      });

    case 'MANUALS_FETCH_SUCCESS':
      return Object.assign({}, state, {
        items: action.manuals,
        isFetching: false,
        isFetched: true
      });

    case 'MANUALS_FETCH_FAILURE':
      return Object.assign({}, state, {
        items: null,
        isFetching: false,
        isFetched: true,
        error: action.error,
        errorMessage: action.errorMessage
      });

    case 'SEND_REMOVE_MANUAL_REQUEST':
      return Object.assign({}, state, {
        manualRemovedByAdmin: false,
      });

    case 'SEND_REMOVE_MANUAL_REQUEST_SUCCESS':
      return Object.assign({}, state, {
        manualRemovedByAdmin: true,
      });

    case 'RESET_REMOVE_MANUAL_FLAG':
      return Object.assign({}, state, {
        manualRemovedByAdmin: false,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/manuals.js